import { Trophy, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { usePaymentRankings } from '../../hooks/usePayments';
import { formatNumber } from '@shared/utils/format';
import type { PaymentRankingItem } from '@shared/types/payment';

function RankBlock({
    title, icon, items, mode,
}: {
    title: string;
    icon: React.ReactNode;
    items: PaymentRankingItem[];
    mode: 'top' | 'inc' | 'dec';
}) {
    return (
        <div className="bg-white rounded shadow-sm border border-[#E6E9ED] p-4">
            <h3 className="text-xs font-bold text-[#2A3F54] uppercase tracking-wider mb-3 flex items-center gap-2">
                {icon} {title}
            </h3>
            <div className="space-y-1.5">
                {items.length === 0 && <p className="text-[12px] text-[#ADB5BD] py-4 text-center">데이터 없음</p>}
                {items.map((it, idx) => (
                    <div key={`${it.townId ?? it.townName}-${idx}`} className="flex items-center gap-2 text-[13px]">
                        <span className="w-5 text-[#ADB5BD] font-medium">{idx + 1}</span>
                        <span className="flex-1 truncate text-[#73879C]" title={it.townName}>{it.townName}</span>
                        {mode === 'top' && <span className="font-semibold text-[#2A3F54]">{formatNumber(it.amount)}원</span>}
                        {mode === 'inc' && <span className="font-semibold text-[#1ABB9C]">+{formatNumber(it.diffAmount)}</span>}
                        {mode === 'dec' && <span className="font-semibold text-[#E74C3C]">{formatNumber(it.diffAmount)}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function PaymentRankings({ ym }: { ym: string }) {
    const { data } = usePaymentRankings(ym);
    return (
        <div className="grid grid-cols-3 gap-4 mb-5">
            <RankBlock title="결제금액 Top 10" icon={<Trophy className="w-3.5 h-3.5 text-[#F39C12]" />} items={data?.top ?? []} mode="top" />
            <RankBlock title="증가 Top 10" icon={<ArrowUpRight className="w-3.5 h-3.5 text-[#1ABB9C]" />} items={data?.increased ?? []} mode="inc" />
            <RankBlock title="감소 Top 10" icon={<ArrowDownRight className="w-3.5 h-3.5 text-[#E74C3C]" />} items={data?.decreased ?? []} mode="dec" />
        </div>
    );
}
